/**
 * Secondary Navigation Component
 */
export class GMXSecondaryNav extends HTMLElement {
	linksDropdownBtn: HTMLButtonElement
	secNavListEl: HTMLElement
	mobileFlyoutMenuEl: HTMLElement
	navContainer: HTMLElement

	private intersectionObserver: IntersectionObserver

	private _flyoutId: string

	constructor() {
		super()

		this._flyoutId = `secnavflyout-${window.crypto.randomUUID()}`
	}

	connectedCallback(): void {
		this.linksDropdownBtn = this.querySelector('button.links-dropdown')
		this.secNavListEl = this.querySelector('.gmx-secondary-nav-list')
		this.mobileFlyoutMenuEl = document.getElementById(this._flyoutId)
		this.navContainer = this.querySelector('.nav-container')

		/* Must Create a new flyout (gmx-flyout) element for the mobile dropdown menu experience */
		if (this.linksDropdownBtn && this.secNavListEl && !this.mobileFlyoutMenuEl) {
			this.mobileFlyoutMenuEl = document.createElement('gmx-flyout')
			this.mobileFlyoutMenuEl.id = this._flyoutId
			this.mobileFlyoutMenuEl.classList.add('gmx-flyout-dropdown')
			this.mobileFlyoutMenuEl.setAttribute('close-on-selection', 'true')

			const flyoutList = this.secNavListEl.cloneNode(true) as Element
			flyoutList.setAttribute('class', '')

			flyoutList.querySelectorAll('li > a, li > button').forEach((el) => {
				el.classList.remove('gmx-btn-link-primary')
				el.classList.add('gmx-btn-secondary')
			})

			this.mobileFlyoutMenuEl.appendChild(flyoutList)

			this.linksDropdownBtn.setAttribute('data-target', this._flyoutId)

			this.appendChild(this.mobileFlyoutMenuEl)
		}

		if (this.navContainer) {
			this.intersectionObserver = new IntersectionObserver(this._handleObservationCallback.bind(this), {
				root: null,
				rootMargin: '0px',
				threshold: 0
			})

			this.intersectionObserver.observe(this)
		}
	}

	disconnectedCallback(): void {
		this.removeChild(this.mobileFlyoutMenuEl)

		this.mobileFlyoutMenuEl = undefined

		if (this.intersectionObserver) {
			this.intersectionObserver.disconnect()
		}
	}

	/**
	 * Method to handle the IntersectionObserver callback to determine whether the fixed secondary nav should be shown or
	 * hidden based on whether the component is within the viewport or not
	 * @param entries
	 * @private
	 */
	private _handleObservationCallback(entries: IntersectionObserverEntry[]): void {
		entries.forEach(entry => {
			const componentClientRect = entry.boundingClientRect

			if (componentClientRect.top <= 0 && !entry.isIntersecting) {
				// If the component is at or above the top of the viewport, then we need to show the fixed bar
				this.navContainer.classList.add('show-sec-nav')
			} else {
				// If the component is below the top of the viewport, then we need to hide the fixed bar
				this.navContainer.classList.remove('show-sec-nav')
			}
		})
	}
}

if (!customElements.get('gmx-secondary-nav')) {
	customElements.define('gmx-secondary-nav', GMXSecondaryNav);
}
